
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.143 13.714h2.571v-2.571h1.715v2.571H18v1.715h-2.571V18h-1.715v-2.571h-2.571v-1.715zm-2.572-.428a4.711 4.711 0 01-4.38-3h7.543a5.088 5.088 0 00-2.108 2.88c-.343.077-.695.12-1.055.12zm-3-5.572A1.284 1.284 0 014.286 6.43c0-.712.574-1.286 1.285-1.286.712 0 1.286.574 1.286 1.286 0 .711-.574 1.285-1.286 1.285zm6 0a1.284 1.284 0 01-1.285-1.285c0-.712.574-1.286 1.285-1.286.712 0 1.286.574 1.286 1.286 0 .711-.574 1.285-1.286 1.285zm-3 7.715l.918-.06c.094.582.282 1.14.557 1.645a8.42 8.42 0 01-1.475.129C3.831 17.143 0 13.286 0 8.57 0 3.857 3.831 0 8.571 0c4.715 0 8.572 3.857 8.572 8.571 0 .506-.043.995-.129 1.475a5.12 5.12 0 00-1.645-.557l.06-.918A6.855 6.855 0 008.57 1.714a6.855 6.855 0 00-6.857 6.857 6.855 6.855 0 006.857 6.858z","fill":"#C08C1D"}})])
          )
        }
      }
    